<template>
  <div>
    <el-dialog
      title="项目配发物资"
      :visible.sync="dialogVisible"
      :width="$store.getters.tagsView ? '60%':'96%'"
      :top="$store.getters.tagsView ? '15vh':'5vh'"
      :close-on-press-escape="false"
      @close="handleClose"
      class="dialog_joindesc"
    >
      <div v-loading="loading">
        <div class="scroll_wrap">
          <div class="wrap" v-for="(lis,index) in list" :key="index+'gp'">
            <div class="gp_title">
              <img :src="lis.configureType == 0 ? src.img1 : src.img2" alt />
              <span>{{lis.title}}：</span>
            </div>
            <p class="manpower-title">服装配置</p>
            <el-button
              type="primary"
              icon="el-icon-circle-plus"
              @click="handleClothIng('add',null,lis.configureType)"
              v-if="lis.projectClothing.length <= 0 "
              size="small"
              :disabled="ClothingList.length <= 0"
            >{{ClothingList.length > 0 ? '添加服装' :'暂无服装'}}</el-button>
            <el-row
              class="manpower-list project_mater"
              v-for="(item,index) in lis.projectClothing"
              :key="'cloth'+index"
            >
              <div class="manpower-item">
                <span class="name">名称：</span>
                <el-select
                  v-model="item.materialName"
                  placeholder="请选择"
                  @change="handleChange1(item)"
                >
                  <el-option
                    v-for="cloth in ClothingList"
                    :key="'cloth' + cloth.id"
                    :label="cloth.name"
                    :value="cloth.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="manpower-item" v-if=" ClothingList.length">
                <span class="name">尺寸：</span>
                <el-select v-model="item.materialModel" placeholder="请选择" filterable :default-first-option="true" allow-create  @blur="selectBlur($event,item)">
                  <el-option
                    v-for="clothsize in ClothingList[item.index?item.index:0].modelList"
                    :key="'clothsize' + clothsize.id"
                    :label="clothsize.name"
                    :value="clothsize.name"
                  ></el-option>
                </el-select>
              </div>
               <div class="manpower-item">
                <span class="name">数量：</span>
                <el-input v-model="item.num" type="number" @input="handleInputInt(item,'num')"></el-input>
              </div>
            <div class="manpower-item manpower-item-money">
                <span class="name">服装单价：</span>
                <el-input v-model="item.price" type="number" @input="handleInputInt(item,'price')"></el-input>
                <span>元</span>
            </div>
            <div class="manpower-item">
                <span class="name">配发时间：</span>
                <el-date-picker
                size="small"
                type="date"
                placeholder="选择日期"
                v-model="item.allotDate"
                value-format="yyyy-MM-dd"
                ></el-date-picker>
            </div>
            <div class="manpower-item">
                <span class="name">备注：</span>
                <el-input v-model="item.remark" placeholder="输入备注"></el-input>
            </div>
              <!-- 添加删除按钮 -->
              <div>
                <div
                  class="item-main-blue"
                  @click="handleClothIng('add',index,lis.configureType)"
                  title="添加服装"
                >
                  <i class="el-icon-circle-plus"></i>
                </div>

                <div
                  class="item-main-rem"
                  @click="handleClothIng('remove',index,lis.configureType)"
                  title="删除服装"
                >
                  <i class="el-icon-delete"></i>
                </div>
              </div>
            </el-row>
            <!-- 分割线 -->
            <div class="line"></div>
            <!-- 分割线 -->
            <p class="manpower-title">装备配置</p>
            <el-button
              type="primary"
              icon="el-icon-circle-plus"
              @click="handleMateriel('add',null,lis.configureType)"
              v-if="lis.projectMateriel.length <= 0"
              size="small"
              :disabled="EquipmentsList.length <= 0"
            >{{EquipmentsList.length > 0 ? '添加装备' :'暂无装备'}}</el-button>
            <el-row
              class="manpower-list project_mater"
              v-for="(item,index) in lis.projectMateriel"
              :key="'mater' + index"
            >
              <div class="manpower-item">
                <span class="name">名称：</span>
                <el-select
                  v-model="item.materialName"
                  placeholder="请选择"
                  @change="handleChange2(item)"
                >
                  <el-option
                    v-for="equi in EquipmentsList"
                    :key="'equi' + equi.id"
                    :label="equi.name"
                    :value="equi.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="manpower-item" v-if=" EquipmentsList.length">
                <span class="name">型号：</span>
                <el-select v-model="item.materialModel" placeholder="请选择" filterable :default-first-option="true" allow-create  @blur="selectBlur($event,item)">
                  <el-option
                    v-for="equisize in EquipmentsList[item.index?item.index:0].modelList"
                    :key="'equisize'+ equisize.id"
                    :label="equisize.name"
                    :value="equisize.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="manpower-item">
                <span class="name">数量：</span>
                <el-input v-model="item.num" type="number" @input="handleInputInt(item,'num')"></el-input>
              </div>
               <div class="manpower-item manpower-item-money">
                <span class="name">服装单价：</span>
                <el-input v-model="item.price" type="number" @input="handleInputInt(item,'price')"></el-input>
                <span>元</span>
            </div>
            <div class="manpower-item">
                <span class="name">配发时间：</span>
                <el-date-picker
                size="small"
                type="date"
                placeholder="选择日期"
                v-model="item.allotDate"
                value-format="yyyy-MM-dd"
                ></el-date-picker>
            </div>
            <div class="manpower-item">
                <span class="name">备注：</span>
                <el-input v-model="item.remark" placeholder="输入备注"></el-input>
            </div>

              <div>
                <!-- 添加删除按钮 -->
                <div
                  class="item-main-blue"
                  @click="handleMateriel('add',index,lis.configureType)"
                  title="添加装备"
                >
                  <i class="el-icon-circle-plus"></i>
                </div>

                <div
                  class="item-main-rem"
                  @click="handleMateriel('remove',index,lis.configureType)"
                  title="删除装备"
                >
                  <i class="el-icon-delete"></i>
                </div>
              </div>
            </el-row>

            <!-- 分割线 -->
            <div class="line"></div>
            <!-- 分割线 -->
            <p class="manpower-title">设备配置</p>
            <el-button
              type="primary"
              icon="el-icon-circle-plus"
              @click="handleEquipments('add',null,lis.configureType)"
              v-if="lis.projectEquipments.length <= 0"
              size="small"
              :disabled="MaterielList.length <= 0"
            >{{MaterielList.length > 0 ? '添加设备' :'暂无设备'}}</el-button>
            <el-row
              class="manpower-list project_mater"
              v-for="(item,index) in lis.projectEquipments"
              :key="'equipments' + index"
            >
              <div class="manpower-item">
                <span class="name">名称：</span>
                <el-select
                  v-model="item.materialName"
                  placeholder="请选择"
                  @change="handleChange3(item)"
                >
                  <el-option
                    v-for="mater in MaterielList"
                    :key="'mater'+mater.id"
                    :label="mater.name"
                    :value="mater.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="manpower-item" v-if=" MaterielList.length">
                <span class="name">型号：</span>
                <el-select v-model="item.materialModel" placeholder="请选择" filterable :default-first-option="true" allow-create  @blur="selectBlur($event,item)">
                  <el-option
                    v-for="matersize in  MaterielList[item.index?item.index:0].modelList"
                    :key="'matersize'+matersize.id"
                    :label="matersize.name"
                    :value="matersize.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="manpower-item">
                <span class="name">数量：</span>
                <el-input v-model="item.num" type="number" @input="handleInputInt(item,'num')"></el-input>
              </div>
               <div class="manpower-item manpower-item-money">
                <span class="name">服装单价：</span>
                <el-input v-model="item.price" type="number" @input="handleInputInt(item,'price')"></el-input>
                <span>元</span>
            </div>
            <div class="manpower-item">
                <span class="name">配发时间：</span>
                <el-date-picker
                size="small"
                type="date"
                placeholder="选择日期"
                v-model="item.allotDate"
                value-format="yyyy-MM-dd"
                ></el-date-picker>
            </div>
            <div class="manpower-item">
                <span class="name">备注：</span>
                <el-input v-model="item.remark" placeholder="输入备注"></el-input>
            </div>

              <div>
                <!-- 添加删除按钮 -->
                <div
                  class="item-main-blue"
                  @click="handleEquipments('add',index,lis.configureType)"
                  title="添加设备"
                >
                  <i class="el-icon-circle-plus"></i>
                </div>

                <div
                  class="item-main-rem"
                  @click="handleEquipments('remove',index,lis.configureType)"
                  title="删除设备"
                >
                  <i class="el-icon-delete"></i>
                </div>
              </div>
            </el-row>
          </div>
        </div>
        <div class="group_footer_btn">
          <el-button type="primary" size="small" @click="handleSure" v-if="!disabled">确 定</el-button>
          <el-button type="primary" size="small" @click="handleSave" v-else>保 存</el-button>
          <el-button @click="handleClose" size="small">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CardProcessChangeProjectMateriel',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: Number,
      default: null
    },
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    dialogLoading: {
      type: Boolean,
      default: false
    },
    DiaLogList: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      ClothingList: [], // 服装名称相关
      MaterielList: [], // 设备相关
      EquipmentsList: [],
      SizeList: [], // 临时保存下data数据
      src: {
        img1: require('@/assets/step/gp.png'),
        img2: require('@/assets/step/zp.png')
      },

      list: [
        {
          title: '公司自配装备',
          configureType: 0,
          projectClothing: [],
          projectMateriel: [],
          projectEquipments: []
        },
        {
          title: '客户配发装备',
          configureType: 1,
          projectClothing: [],
          projectMateriel: [],
          projectEquipments: []
        }
      ]
    }
  },
  created () {
    this.getProjectConfigList()
  },

  computed: {
    dialogVisible: {
      get: function () {
        return this.show
      },
      set: function () {
        return this.show
      }
    },
    disabled () {
      return !!this.dataList.length
    },
    loading () {
      return this.dialogLoading
    }
  },
  methods: {
    //   处理装备和设备的获取情况
    getProjectConfigList () {
      this.ClothingList = this.DiaLogList.DialogClothingList
      this.EquipmentsList = this.DiaLogList.DialogEquipmentsList
      this.MaterielList = this.DiaLogList.DialogMaterielList
      this.handleSplitType()
    },
    // 拆分处理
    handleSplitType () {
      this.list = this.dataList.length ? this.dataList : this.list
    },
    // 添加或者删除服装配置
    handleClothIng (type, val, status) {
      if (status == 0) {
        this._handleRemoveAdd(type, val, status, this.list[0].projectClothing)
      } else {
        this._handleRemoveAdd(type, val, status, this.list[1].projectClothing)
      }
    },
    // 添加或者删除装备配置
    handleMateriel (type, val, status) {
      if (status == 0) {
        this._handleRemoveAdd(type, val, status, this.list[0].projectMateriel)
      } else {
        this._handleRemoveAdd(type, val, status, this.list[1].projectMateriel)
      }
    },
    // 添加或者删除设备配置
    handleEquipments (type, val, status) {
      if (status == 0) {
        this._handleRemoveAdd(
          type,
          val,
          status,
          this.list[0].projectEquipments
        )
      } else {
        this._handleRemoveAdd(
          type,
          val,
          status,
          this.list[1].projectEquipments
        )
      }
    },
    // 处理添加或者删除操作
    _handleRemoveAdd (type, val, status, arr) {
      let obj = {
        materialName: '',
        materialModel: '',
        num: null,
        index: 0,
        remark: '', // 备注
        allotDate: '', // 配发日期
        price: '', // 单价
        configureType: status
      }
      if (type == 'add') {
        arr.push(obj)
      }
      if (type == 'remove') {
        arr.splice(val, 1)
      }
    },
    // 更改或者选择服装
    handleChange1 (val, type) {
      this._handelChange(this.ClothingList, val, type)
    },
    handleChange2 (val, type) {
      this._handelChange(this.EquipmentsList, val, type)
    },
    handleChange3 (val, type) {
      this._handelChange(this.MaterielList, val, type)
    },
    _handelChange (list, val, type) {
      list.forEach((item, index) => {
        if (item.name === val.materialName) {
          val.index = index
          if (type) {
            val.materialModel = val.materialModel ? val.materialModel : ''
          } else {
            val.materialModel = ''
          }

          if (item.modelList.length === 0) {
            item.modelList = [{ name: '默认' }]
            val.materialModel = val.materialModel ? val.materialModel : '默认'
          }
        }
      })
    },
    // 关闭弹窗
    handleClose () {
      this.$emit('close', false)
    },
    // 保存数据
    handleSave () {
      this.$emit('save', this.list)
    },
    // 确定数据
    handleSure () {
      this.$emit('sure', this.list)
    },
    // 可输入文字
    selectBlur (e, val) {
      if (e.target.value) {
        val.materialModel = e.target.value
      }
    },
       handleInputInt(item,str){
         item[str] = item[str].toString().replace(/[^\.\d]/g, "");
    }
  }
}
</script>

<style lang="scss" scoped>
$color_blue: #409eff;
.manpower-title {
  height: 40px;
  line-height: 40px;
  color: #333;
  font-size: 14px;
  margin-bottom: 10px;
}
.wrap {
  padding-bottom: 50px;
  overflow: auto;
}
.wrap:first-child {
  border-bottom: 5px solid #f5f7fa;
  margin-bottom: 40px;
}

.manpower-list {
  display: flex;
  flex-wrap: wrap;
}
.manpower-item {
  font-size: 14px;
  position: relative;
  margin-right: 20px;
  margin-bottom: 15px;
  .name {
    display: inline-block;
    line-height: 32px;
    width: 80px;
  }
}
.suffix-text {
  position: absolute;
  right: 10px;
  top: 0;
  color: #999;
  line-height: 32px;
}
.line {
  height: 1px;
  margin: 19px 0 20px;
  border-bottom: 1px dotted #ddd;
}
.item-main-rem,
.item-main-blue {
  float: left;
  line-height: 32px;
  text-align: center;
  color: #ff5252;
  width: 40px;
  font-size: 22px;
  cursor: pointer;
}
.item-main-blue {
  color: $color_blue;
}
@media screen and (max-width: 670px) {
  .manpower-list {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 520px) {
  .page_btn {
    padding: 20px 5px !important;
  }
}

@media screen and (max-width: 372px) {
  .manpower-main {
    margin: 0 !important;
  }
}
.gp_title {
  color: #001111;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  img {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}
.group_footer_btn {
  text-align: right;
  border-top: 1px solid #eee;
  padding: 20px 0;
}
.staff_box {
  padding: 0 0 30px;
  span {
    color: #001111;
  }
}
.scroll_wrap {
  height: 60vh;
  overflow-y: auto;
  /* 设置滚动条的样式 */
  &::-webkit-scrollbar {
    width: 6px;
    height: 8px;
    background-color: #eee;
    border-radius: 2px;
  }
  /* 滚动条滑块 */
  &::-webkit-scrollbar-thumb {
    width: 4px;
    background: #ddd;
    border-radius: 2px;
  }
}
</style>
<style lang="scss">
.project_mater {
  .manpower-item {
    display: flex;
    .el-date-editor {
      .el-input__inner {
        padding: 0 30px;
      }
    }
    .el-input {
      width: 140px;
    }
    .el-input__inner {
      width: 140px;
      padding: 0 20px 0 10px;
      height: 32px;
      line-height: 32px;
    }
    .el-select__caret {
      line-height: 32px;
    }
    .el-input__icon {
      line-height: 32px;
      height: 32px;
    }
  }
}
.materiel_dialog {
  .el-input,
  .el-select {
    width: 80%;
  }
  .el-select {
    .el-input {
      width: 100%;
    }
  }
}
.manpower-item-money span{
    line-height: 32px;
    padding-left: 10px;
}
</style>
